import React, { useState, useEffect } from 'react';
import Modal from '../../../../../components/molecules/Modal';
import AsyncSelect from 'react-select/async-creatable';
import { searchTags, updateOrderTags } from '../../../../../store/action/order';

export default function (props) {
    const [ tagInput, setTagInput ] = useState("");
    const [ selectedTags, setSelectedTags ] = useState([]);
    const [ loading, setLoading ] = useState({
        loading:false,
        progress:0
    });

    const onChangeTags = (e) => {
        if (e) {
            const selected = e.reduce((r,i) => {
                r.push({label:i.value,value:i.value});
                return r
            },[])
            setSelectedTags(selected);
            return;
        };
        setSelectedTags([]);
        return;
    }

    const getTagsData = async (inputValue) => {
        const result = await searchTags(inputValue);
        if (!result.success) return;
        const formattedResult = result.tags.reduce((r,i) => {
            r.push({label:i,value:i}); return r;
        },[]);
        return formattedResult
    }

    const handleInputChange = (value) => {
        const inputValue = value.replace(/\W/g, '');
        setTagInput(inputValue);
        return inputValue;
    };

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            setTimeout(() => {
                resolve(getTagsData(inputValue));
            }, 1000);
    });
    
    const submitTag = async () => {
        setLoading({...loading,loading:true});
        const data = selectedTags.reduce((r,i) => {
            r.push(i.value); return r;
        },[])
        
        if (props.data.length > 0) {
            for (let i = 0; i < props.data.length;i++) {
                const response = await updateOrderTags(props.data[i].orderId, data);
                if (response.success) {
                    setLoading({...loading,loading:true,progress:i+1})
                } 
            }
            alert(`Success update ${props.data.length} orders`);
            window.location.reload();
            return 
        } else {
            const response = await updateOrderTags(props.orderId, data);
            if (response.success) {
                alert(response.message);
                window.location.reload();
                return 
            } else {
                return alert(response.error);
            }
        }
    }

    return (
        <Modal
            buttons={true}
            show={props.show}
            loading={loading.loading}
            onHide={props.onHide}
            title={"Buat Tags"}
            bodyClassName="p-0"
            size={"md"}
            bText={selectedTags.length > 0 ? "Submit Tag" : "Submit Tag Kosong"}
            bClick={() => submitTag()}
            type={"oneButton"}
        >
            <div className="p-4">
                { 
                    props.data.length > 0 ? 
                        <h6>
                            Update tags {props.data.length} pesanan
                        </h6>
                        :
                        <h6>
                            Update tags order #{props.orderId.toUpperCase()}
                        </h6>
                }
                <AsyncSelect
                    isMulti
                    cacheOptions
                    value={selectedTags}
                    onChange={e => onChangeTags(e)}
                    loadOptions={promiseOptions}
                    defaultOptions
                    onInputChange={handleInputChange}
                    placeholder="Masukkan tag order Anda"
                />
            </div>
        </Modal>
    )
}